module.exports = __webpack_public_path__ + "img/VEC-logo-refresh.4eaf0085.svg";